<div class="outer" [class.disabled]="disabled()" (click)="toggle()">
  <div class="inner">
    @if (checked()) {
      <div class="radio"></div>
    }
  </div>
</div>
